module.exports = __webpack_public_path__ + "static/media/queenofpeace.090fc569.webp";